<template>
    <div class="support">
        <div class="title">技术支持</div>
        <div class="tips">您的安心之选</div>

        <div class="support-list">
            <div class="support-item" v-for="(item, index) in supportItems" :key="index" :data-index="index + 1">
                <div class="index">{{ index + 1 }}</div>
                <img :src="item.img">
                <div class="support-title">{{ item.title }}</div>
                <div class="support-desc">{{ item.desc }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SupportComp',
    data() {
        return {
            supportItems: [
                {
                    img: require('@/assets/image/support_1.webp'),
                    title: '专业品质',
                    desc: '15年专注制冷设备研发'
                },
                {
                    img: require('@/assets/image/support_2.webp'),
                    title: '品质保证',
                    desc: 'ISO9001质量管理体系认证'
                },
                {
                    img: require('@/assets/image/support_3.webp'),
                    title: '技术支持',
                    desc: '7*24小时专业服务'
                },
                {
                    img: require('@/assets/image/support_4.webp'),
                    title: '安装调试',
                    desc: '专业团队上门服务'
                },
                {
                    img: require('@/assets/image/support_5.webp'),
                    title: '定制方案',
                    desc: '根据需求量身定制'
                },
                {
                    img: require('@/assets/image/support_6.webp'),
                    title: '售后无忧',
                    desc: '完善的售后服务体系'
                }
            ]
        }
    }
}
</script>

<style scoped lang="scss">
.support {
    padding: 80px 40px 48px;
    box-sizing: border-box;
    width: 100%;
    background: #FFF;

    .title {
        color: #000000;
        font-family: "Inter";
        font-size: 30px;
        font-style: normal;
        font-weight: 700;
        line-height: 36px;
        text-align: center;
        margin-bottom: 18px;
    }

    .tips {
        color: #4B5563;
        font-family: "Inter";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        text-align: center;
        margin-bottom: 50px;
    }

    .support-list {
        display: flex;
        gap: 32px;
        flex-wrap: wrap;
        margin-bottom: 32px;

        .support-item {
            flex: 1 1 25%;
            box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
            border-radius: 12px;
            padding: 32px;

            .index {
                color: rgba(42, 91, 218, 0.20);
                font-family: "Inter";
                font-size: 36px;
                font-style: normal;
                font-weight: 700;
                line-height: 40px;
                margin-bottom: 14px;
            }

            img {
                width: 48px;
                height: 48px;
                margin-bottom: 18px;
            }

            .support-title {
                color: #000000;
                font-family: "Inter";
                font-size: 20px;
                font-style: normal;
                font-weight: 600;
                line-height: 28px;
                margin-bottom: 12px;
            }

            .support-desc {
                color: #4B5563;
                font-family: "Inter";
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 24px;
            }
        }
    }
}

.support-item {
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    }
}

@media (max-width: 768px) {
    .support {
        padding: 40px 20px;

        .support-list {
            gap: 12px;

            .support-item {
                flex: 1 1 25%;
            }
        }
    }
}
</style>